/* eslint-disable */
import React,{useState, useEffect} from 'react';
import { DataGrid,
    GridToolbarContainer,
    GridToolbarExport, gridClasses, } from '@mui/x-data-grid';
import {  Box, CircularProgress,Stack,
    Stepper, Step, StepLabel, 
    TextField,InputAdornment, Button, 
    TableHead, Table, TableBody,TableCell,TableRow,LinearProgress } from '@mui/material';

    
import Autocomplete from '@mui/material/Autocomplete';
import SavedDataDropDown from '../customComponents/saved_data_dropdown'
import {ScrapeYelp,YelpCategories} from '../data/api';
import SearchIcon from '@mui/icons-material/Search';

const yelp_url = 'https://www.yelp.com/developers/documentation/v3/all_category_list/categories.json'
/*

main difference between this and google scrale is the options will come from
a get request of the yelp options
*/


const handle_csv = (csv) => {
    var list = csv.split('\r\n')
    if (list.length <=1){
        list = csv.split('\r')
    }
    if (list.length <=1){
        list = csv.split('\n')
    }
    const cols = list[0].split(',')
    const vals = list.slice(1)

    return (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
                <TableRow>
                    {cols.map((val, idx)=>{return <TableCell align="center">{val}</TableCell>})}
                </TableRow>
            </TableHead>
            <TableBody>
            {vals.map((row,idx)=>{// vall is a row of csv val1,vas2, val3

             return (<TableRow>
                 {row.split(',').map((val, idx)=>{
                     return <TableCell align="center">{val}</TableCell>
                     })}
             </TableRow>)
            })}

            </TableBody>
      </Table>
    )
}

function CustomToolbar() {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

export default function YelpScraper(){
    const [yelpOptions,setYelpOptions] = useState();
    const [selectOption,setSelectOption] = useState();
    const [tag,setTag] = useState(null);
    const [radius,setRadius] = useState(null);

    const [progress,setProgress] = useState(5);
    const [loading,setLoading] = useState(false);
    //Could use a big dict, but this feel easier ot com back to
    const [search,setSearch] = useState('Coffee Shops in {city}, {state}');
    const [csv,setCSV] = useState('');
    const [csvCols,setCsvCols] = useState([]);
    
    const [step,setStep] = useState(0);
    const [mapsData,setMapsData] = useState([]);
    const [mapsDataContainer,setMapsDataContainer] = useState([]);
    const [expectedReturnCount,setExpectedReturnCount] = useState([]);
    const [returnTable,setReturnTable] = useState(<></>);
    const [detailReturnTable,setDetailReturnTable] = useState(<></>);

    useEffect(()=>{
        YelpCategories().then((r)=>{         
            setYelpOptions(r.data.categories)
        })

    },[])

    useEffect(()=>{
        setSelectOption(selectOption)
    },[selectOption])

    useEffect(()=>{
        if (mapsData!= null){
        const new_ = mapsDataContainer.concat(mapsData)
        setMapsDataContainer(new_)
        }
    },[mapsData])


    useEffect(()=>{
        if (mapsDataContainer!= null){
            setProgress((expectedReturnCount/mapsDataContainer.length) * 100)
            update_return_table()
        }
        if(expectedReturnCount/mapsDataContainer.length==1){
            setLoading(false);
        }
    },[mapsDataContainer])

    const steps = [
        'Select Yelp categories',
        'Upload cities, choose scraping options',
        'Check paramets, run scrape.'

    ]

    //is this more or less clear than just calling it?
    const update_return_table = () =>{
        setReturnTable(createReturnTable(mapsDataContainer))
        try{
            setDetailReturnTable(createDetailReturnTable(mapsDataContainer))}catch(e){
            console.log(e)
        }
    }

    const execute_search = () => {

        if (csv==null || search==null){
            alert('Please make sure a valid query and csv were given.')
            return ''
        }
        setLoading(true);

        const list = csv.split('\r\n')
        const cols = list[0].split(',')
        setCsvCols(cols)
        
        const vals = list.slice(1)
        var data;
        // create a list of requests to send to backend
        if (cols.length == 2){
            //bad bud gonna ssume 2 cols is og format
             data = vals.map((val, idx)=>{
                var categories;
                const vals = val.split(',')
                try{ categories = selectOption.map((val)=>{return val.alias}).join(',');}catch(e){ categories = ''}
                return {state:vals[1], city:vals[0], term:tag, categories:categories, radius:radius}
            });
        } else {
             data = vals.map((val, idx)=>{
                const vals = val.split(',')
                var categories;
                try{ categories = selectOption.map((val)=>{return val.alias}).join(',');}catch(e){ categories = ''}
                return {
                        state:null, 
                        city:null, 
                        term:tag, 
                        categories:categories, 
                        radius:radius, 
                        latitude:vals[1], 
                        longitude:vals[2]}
                });
        }

        setExpectedReturnCount(vals.length)
        data.map((req,idx)=>{
            setTimeout(()=>{
                ScrapeYelp(req)
                 .then((r)=>{
                    console.log('DATA:',r.data);
                    setMapsData(r.data)
                    })
                 .catch((e)=>{console.log(e)})
        },idx*1000)
    })
    }

 const createDetailReturnTable = (data_) =>{

        if (data_.length==0){
            return <></>
        }
        var data = data_.map((val)=>{
            if(val['details'].length!=0){
                var data = val['details']
                if(val.city==null||val.state==null){
                    data = data.map((x)=>{
                        x['lat']=val.latitude
                        x['lon']=val.longitude
                        return x
                    })
                    
                }
                return data
            }
        });
        
        data = data.filter(function( element ) {
            return element !== undefined;
         });
        if (data_[0].length==0){
            return <></>
        }

        var columns = [
            { field: 'id', headerName: 'ID', width: 70},
            { field: 'name', headerName: 'Name', width: 70} ,
            { field: 'alias', headerName: 'Alias', width: 70} ,
            { field: 'price', headerName: 'Price', width: 70} ,
            { field: 'rating', headerName: 'Rating', width: 70} ,
            { field: 'review_count', headerName: 'Reviews', width: 70} ,
            { field: 'transactions', headerName: 'Transactions', width: 70} ,
            { field: 'categories', headerName: 'Categories', width: 70},
            { field: 'image_url', headerName: 'Image Url', width: 120},
            { field: 'is_closed', headerName: 'Is Closed?', width: 120},
            { field: 'zip', headerName: 'Zip', width: 120},
            { field: 'url', headerName: 'Yelp Url', width: 120},
            { field: 'match', headerName: 'Match', width: 40}
            
        ]
        // if(data_[0].state==null||data_[0].city==null){
        //     columns.push(
        //     {field: 'lat', headerName: 'Latitude', width: 120},
        //     { field: 'lon', headerName: 'Longitude', width: 120})

        // }
   

        data = data.flat(1)
        const rows = data.map((val, idx)=>{
            var transactions = [];
            var categories = val['categories'].map((val)=>{return val['title']});

            var city = val['location']['city'];
            var state = val['location']['state'];
            var zip = val['location']['zip_code'];

            var r = {
                    id:idx, 
                    name:val['name'],
                    alias:val['alias'],
                    price:val['price'],
                    rating:val['rating'],
                    review_count:val['review_count'],
                    transactions:transactions,
                    categories:categories.join(),
                    image_url:val['image_url'],
                    is_closed:val['is_closed'], 
                    city:city,
                    state:state,
                    zip:zip,
                    url:val['url'], 
                    match:val['match']
                 }
                 
            return r      
        })
        
        return (
            <div style={{ height: '600px', width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection
                    components={{
                        Toolbar: CustomToolbar,
                      }}
                />
            </div>
        )
    
    }


    const createReturnTable = (data) =>{
        if (data.length==0){
            return <></>
        }
        const columns = [
            { field: 'id', headerName: 'ID', width: 70},
            { field: 'count', headerName: 'Count', width: 70} ,
            { field: 'match', headerName: 'Match', width: 70} ,
        ]

        console.log('table date',data);

        const rows = data.map((val, idx)=>{
            
        return {id:idx, count:val['count'], state:val['state'],match:val['match']  }
            
            
        })
        
        return (
            <div style={{ height: '600px', width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection
                    components={{
                        Toolbar: CustomToolbar,
                      }}
                />
            </div>
        )
    
    }

    const  CityStep = (p) => {
        return (
            <SavedDataDropDown
                setData={setCSV}
                button={
                <Button
                    variant="contained"
                    component="label"
                    >
                    Upload File
                    <input
                        onChange={p.onChange}
                        type="file"
                        hidden
                    />
                </Button>}
                />
        )
    }
    
    const ExecuteStep = () => {
        return (
            <Box align="center" sx={{ height:40, width: '100%' }}>
                <Stack>
                    <Button 
                    onClick={execute_search}
                    >Execute</Button>
                </Stack>
           
           
            </Box>
            )
    }

    const load_file = (e)=> {
        var reader = new FileReader()
        reader.onload = () =>{
            
            setCSV(reader.result)
        }
    
    }


    const mapping = {
        //weird begin when creating ): was insid efunciton in component
        0:<>{yelpOptions==null?
            <></>:<>
            <Autocomplete
                multiple
                value={selectOption}
                onChange={(event, newValue) => {setSelectOption(newValue);}}
                id="yelp-options"
                options={yelpOptions}
                getOptionLabel={(yelpOptions) => yelpOptions.title}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField
                    {...params}
                    variant="standard"
                    label="Yelp Categories"
                    placeholder="..."
                />}
            />
            <TextField 
                value={tag} 
                onChange={(e)=>{setTag(e.target.value)}} 
                id="tag" 
                label="Optional Search Tag.." 
                variant="standard" />
            <TextField 
                value={radius} 
                onChange={(e)=>{setRadius(e.target.value)}} 
                id="radius" 
                label="Optional Radius (Meters)" 
                variant="standard" />
                </>
            }</>,
        1:<CityStep onChange={load_file}  />,
        2:<ExecuteStep/>,
    }

    
    
    const MyStepper =()=>{
        return(
            <Box display='flex' sx={{ width: '100%' }}>
            <Stepper activeStep={step} alternativeLabel>
                {steps.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
                ))}
            </Stepper>
        </Box>
        )
    }
    
    return (
       

            <div>
                <Box sx={{height:100}}></Box>
            <MyStepper/>
            <Stack>
                <Box sx={{height:100}}></Box>
                {mapping[step]}
                <Box sx={{height:100}}></Box>
            <Box 
                m={1}
                component="span"
                justifyContent= "space-between"
                sx={{
                  alignItems: "center",
            }}
            >
            {step>0?<Button 
                component="label"
                onClick={()=>{setStep(step-1)}}> Previous</Button>:<Button disabled>Previous</Button>}              
            
                {step >=2? <Button disabled>Next</Button>:<Button
                component="label" onClick={()=>{setStep(step+1)}}>Next</Button> }
            </Box>    
            {csv != null && step==1? <div>{handle_csv(csv)}</div>: <></>}
            {mapsDataContainer.length==0?<></>:<div>{returnTable}</div>}
            {mapsDataContainer.length==0?<></>:<div>{detailReturnTable}</div>}
         </Stack>
         </div>
        )
}


